import { Point } from 'geojson';
import { TenantGeneralData } from './../tenantGeneralData';
import { Insect } from './insect';
import { Device } from '../device';
import { Crop } from '../crop';
import { AlertThreshold, ThresholdLevels } from './alertThreshold';

export class InsectsZone extends TenantGeneralData {
  name: string;
  sensor?: Device;
  sensorId: number;
  sensorIsVirtual: boolean;
  sensorDid: string;
  sensorTypeCode: string;
  weatherStation?: Device;
  weatherStationId: number;
  weatherStationDid: string;
  weatherStationTypeCode: string;
  weatherStationIsVirtual: boolean;
  cropIds: Array<number>;
  crops: Array<Crop>;
  insectId: number;
  insect?: Insect;
  alertThreshold: AlertThreshold;
  areaRadius: number;
  areaCenter: string;
  point?: Point;
  countDelta: number;
  count?: number;
  statusPheroPercent: number;
  statusPaperPercent: number;
  infestationLvl: string;
  dailyLowThres: number;
  dailyHighThres: number;
  logoPath: string;
  hasImageRekognition: boolean;

  constructor() {
    super();
    this.name = null;
    this.sensorId = null;
    this.sensorIsVirtual = null;
    this.sensorDid = null;
    this.sensorTypeCode = null;
    this.weatherStationId = null;
    this.weatherStationDid = null;
    this.weatherStationTypeCode = null;
    this.weatherStationIsVirtual = null;
    this.cropIds = [];
    this.crops = [];
    this.insectId = null;
    this.alertThreshold = null;
    this.areaRadius = null;
    this.areaCenter = null;
    this.point = null;
    this.countDelta = null;
    this.count = 0;
    this.statusPheroPercent = null;
    this.statusPaperPercent = null;
    this.infestationLvl = null;
    this.dailyLowThres = null;
    this.dailyHighThres = null;
    this.logoPath = null;
    this.hasImageRekognition = null;
  }

  static LEVELS = [
    ThresholdLevels.LOW,
    ThresholdLevels.MEDIUM_LOW,
    ThresholdLevels.MEDIUM,
    ThresholdLevels.MEDIUM_HIGH,
    ThresholdLevels.HIGH,
  ];
}

// package com.xfarm.api.v2.insects

// import com.mongodb.BasicDBObject
// import com.xfarm.api.v1.core.Crop
// import com.xfarm.api.v2.alert.AlertThreshold
// import grails.mongodb.geo.Point

// class InsectZone {
//     static mapWith = "none"

//     Long        id
//     Long        companyId = -1
//     string      name
//     Long        sensorId
//     string      sensorDid
//     boolean     sensorIsVirtual
//     string      sensorTypeCode
//     Long        weatherStationId
//     string      weatherStationDid
//     string      weatherStationTypeCode
//     boolean     weatherStationIsVirtual
//     List<Long>  cropIds
//     List<Crop> crops
//     Long        insectId
//     AlertThreshold alertThreshold
//     Double      areaRadius
//     string      areaCenter
//     Point       point
//     Integer     countDelta
//     Double      statusPheroPercent
//     Double      statusPaperPercent
//     string      infestationLvl
//     Integer     dailyLowThres
//     Integer     dailyHighThres
//     string      logoPath
//     boolean     hasImageRekognition

//     static embedded = [
//         'alertThreshold'
//     ]

//     static constraints = {
//         companyId                   nullable: false, blank: false
//         name                        nullable: false
//         sensorId                    nullable: true
//         sensorDid                   nullable: true
//         sensorIsVirtual             nullable:true
//         sensorTypeCode              nullable: true
//         weatherStationId            nullable: true
//         weatherStationIsVirtual     nullable: true
//         weatherStationDid           nullable: true
//         weatherStationTypeCode      nullable: true
//         insectId                    nullable: false
//         alertThreshold              nullable: true
//         areaRadius                  nullable: true
//         areaCenter                  nullable: true
//         point                       nullable: true, bindable: false, blank: true
//         countDelta                  nullable: true
//         statusPheroPercent          nullable: true
//         statusPaperPercent          nullable: true
//         infestationLvl              nullable: true
//         dailyLowThres               nullable: true
//         dailyHighThres              nullable: true
//         logoPath                    nullable: true
//         hasImageRekognition         nullable: true
//     }

//     Point getPoint() {
//         return this.point
//     }
//     void setPoint(Point point) {
//         this.point = point
//     }

//     string getAreaCenter() {
//         return polygonToGeoJsonMap(this.point?.getY(), this.point?.getX())
//     }

//     void setAreaCenter(string areaCenter) {
//         this.pointForGeoJson(areaCenter)
//         this.areaCenter = areaCenter
//     }

//     static Map polygonToGeoJsonMap(Double lat, Double lng) {
//         lat && lng ? [
//             "type":"Feature",
//             "properties":[],
//             "geometry":
//                     [
//                             "type":"Polygon",
//                             "coordinates": [lng, lat]
//                     ]
//         ] : null
//     }

//     void pointForGeoJson(string areaCenter){
//         BasicDBObject areaParsed = BasicDBObject.parse(areaCenter)
//         if (areaParsed) {
//             List coordsTMP = areaParsed.getAt('geometry')?.getAt('coordinates')
//             this.setPoint(Point.valueOf(coordsTMP))
//         }
//     }

//     InsectZone init(XTrapMonitoringPeriodListDetail data){
//         if(data) {
//             this.companyId = data.farmId
//             this.id = data.monitoringPeriodId
//             this.name = data.name
//             this.cropIds = data.cropIds
//             this.sensorId = data.deviceId
//             this.sensorDid = data.did
//             this.sensorTypeCode = data.deviceTypeId
//             this.weatherStationDid = data.degreeDaysDid
//             this.weatherStationTypeCode = data.degreeDaysDeviceTypeId
//             this.insectId = data.insectId
//             this.countDelta = data.countDelta
//             this.statusPheroPercent = data.statusPheroPercent
//             this.statusPaperPercent = data.statusPaperPercent
//             this.infestationLvl = data.infestationLvl
//             this.dailyHighThres = data.dailyHighThres
//             this.dailyLowThres = data.dailyLowThres
//             this.logoPath = data.logoPath
//             this.hasImageRekognition = data.hasImageRekognition
//             if (data.longitude && data.latitude) {
//                 this.point = new Point(data.longitude, data.latitude)
//             }
//             this.areaRadius = data.radius
//             return this
//         } else {
//             return null
//         }
//     }
// }
